import { db, storage, functions } from '@/firebase'
import { randomString, createSlug } from '@/utils/utils.js'


export default {
    getDirectorioGest({ commit, rootState }) {
        console.log(rootState.app);
        return db.collection('directorios').doc(rootState.app.directorioGest).get()
            .then((res) => {
                if (res.exists) {
                    commit('app/setDirectorioObjGest', {
                        ...res.data(),
                        id: res.id
                    }, { root: true })
                }
                return;

            })
    },
    getDirectorios({ commit }) {
        return db.collection('directorios').get()
            .then((res) => {
                commit('setDirectorios', res.docs.map(d => {
                    return {
                        ...d.data(),
                        id: d.id
                    }
                }))
            })
    },
    async saveDirectorio({ }, directorio) {
        let id = directorio.id ? directorio.id : createSlug(directorio.nombre);
        delete directorio.id;
        if (directorio && directorio.configuracion && directorio.configuracion.multipleExclusivo) { //es multiple exclusivo y hay que buscar un restaurante para marcarlo como matriz
            let grupo = directorio.configuracion.multipleExclusivoGrupo
            let foundGrupo = directorio.configuracion.gruposAceptaMultiple.find(g => g.id == grupo);
            if (foundGrupo && foundGrupo.restauranteMatriz)
                await db.collection('restaurantes').doc(foundGrupo.restauranteMatriz).set({ directorioMatriz: id }, { merge: true })
        }
        if (!directorio.cod) {
            let cod = randomString(6);
            directorio.cod = cod;
        }
        var secreto = {};
        // if (negocio.printNode) {
        //     secreto.keyPrintNode = negocio.keyPrintNode
        //     delete negocio.keyPrintNode;
        // }
        // if (negocio.vromo) {
        //     secreto.vromoApikey = negocio.vromoApikey
        //     delete negocio.vromoApikey;
        // }
        let ref = db.collection('directorios').doc(id).set(directorio, { merge: true })
        return ref
            .then((res) => {
                if (!id) {
                    id = res.id;
                }
                var promesas = [];
                if (Object.keys(secreto).length > 0) {
                    let p_secreto = db.collection('directorios').doc(id)
                        .collection('secreto').doc('apikey').set(secreto, { merge: true })
                    promesas.push(p_secreto);
                }
                return Promise.all(promesas);
            })
    },
    getCategoriasNegocios({ commit, rootState }) {
        return Promise.all([
            rootState.app.directorioObjGest.negocios.map(n => {
                return db.collection('negocios').doc(n).collection('categorias').get()
                    .then((res) => {
                        res.docs.map(c => {
                            return {
                                ...c.data(),
                                id: c.id
                            }
                        })

                    })
            })
        ])
            .then(r => {

            })
    },
    saveFacturacion({ }, payload) {
        return db.collection('directorios').doc(payload.id)
            .collection('secreto').doc('facturacion').set(payload.facturacion, { merge: true })
    },

    getFacturacion({ }, id) {
        return db.collection('directorios').doc(id)
            .collection('secreto').doc('facturacion').get()
            .then((r) => {
                if (r.exists) {
                    return r.data();
                }
            })
    },
}